<div class="grid-container margin-top full-height">
    <co-report></co-report>
</div>